import { render, staticRenderFns } from "./GamesCombi.vue?vue&type=template&id=d133d86e"
import script from "./GamesCombi.vue?vue&type=script&lang=js"
export * from "./GamesCombi.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports